import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type { IMeasurementUnitKindResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IMeasurementUnitKindResponse>>,
  IPathBaseParam,
  IPaginationParams
>("measurementUnitKinds");

export const measurementUnitKinds = {
  ...getAllApis,
};
